import type { PaymentMethodSaveModes } from '../../../services/commonCheckout/types/SessionConfig/Options';

interface ShouldShowSaveOptionsParams {
  isGuestUser: boolean;
  paymentMethodSaveMode: PaymentMethodSaveModes | null;
  showSaveFeatureBlock: boolean;
}

export const shouldShowSaveOptions = ({
  isGuestUser,
  paymentMethodSaveMode,
  showSaveFeatureBlock,
}: ShouldShowSaveOptionsParams): boolean => {
  if (isGuestUser) {
    return false;
  } else if (paymentMethodSaveMode === 'DISABLE_SAVE') {
    return false;
  } else if (!showSaveFeatureBlock) {
    return false;
  } else {
    return true;
  }
};
